import { createContext } from 'use-context-selector';
import { EventEmitter } from '@meitu/saas-editor-core/es/framework';
import { GroupRoleType, LayerType } from '@meitu/saas-editor-core/es/version-types';
import { ICallback } from '../types';

export interface IHeaderToolbarContext extends ICallback {
    id: string;
    textLayerId: string | null;
    lock: boolean;
    layerType: LayerType;
    pickLayerType: LayerType | null;
    thumbnail: string | null;
    hideCopyBtn: boolean;
    isIntl?: boolean;
    events?: EventEmitter;
    style?: React.CSSProperties;
    role: GroupRoleType | null;
}

export const HeaderToolbarContext = createContext<IHeaderToolbarContext>({} as IHeaderToolbarContext);
